import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {config } from "../../api/config.js";
const apiUrl = process.env.REACT_APP_URL;

// add new card
export const addNewCard = createAsyncThunk(
  "gcard/add",
  async (card, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await axios.post(`${apiUrl}/gcard/add`, card,config);
      if (res.status === 201) {
        return res.data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);
// update card
export const updateGCard = createAsyncThunk(
  "gcard/update",
  async (payload, thunkApi) => {
    const { rejectWithValue } = thunkApi;
     const {id,values} = payload; 
    try {
      const res = await axios.put(`${apiUrl}/gcard/update/${id}`,values,config);
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);
// delete card
export const deleleteGcard = createAsyncThunk(
  "gcard/delete",
  async (id, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await axios.delete(`${apiUrl}/gcard/delete/${id}`,config);
      if (res.status === 200) {
        return res.data.id;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);
// get card
export const getCard = createAsyncThunk(
  "gcard/fetchOne",
  async (serial, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await axios.get(`${apiUrl}/gcard/fetchOne?id=${serial}`);
      if (res.status === 200) {
        return res.data.card;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);
// fetch cards
export const getCards = createAsyncThunk(
  "gcard/fetch",
  async (filter, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    const {startDate , endDate ,paymentType,employee} = filter;
    try {
      const res = await axios.get(`${apiUrl}/gcard/fetch?startDate=${startDate}&endDate=${endDate}&paymentType=${paymentType}&employee=${employee}`,config);
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);
// get serial bussiness card for branch 
export const getBussinesCradSerial = createAsyncThunk(
  "gcard/branchserial",
  async (branch, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await axios.get(`${apiUrl}/gcard/branchserial?branch=${branch}`, config);
      if (res.status === 200) {
        return res.data.serial;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);



